import * as React from "react";
import { Redirect } from "react-router-dom";
import { connect } from "react-redux";
import UserAdmin from "../../containers/UserAdmin";

interface ConnectedProps {
  user: Insite.AppState["auth"]["user"];
}

type Props = ConnectedProps;

function mapStateToProps(state: Insite.AppState) {
  return {
    user: state.auth.user,
  };
}

const UserAdminScene = ({ user = { access: [] } }: Props) => {
  if (user.access && !user.access.includes("userAdmin"))
    return <Redirect to="/404" />;
  return <UserAdmin />;
};

export default connect(mapStateToProps)(UserAdminScene);
